<template>
  <basic-container>
    <avue-crud
        :option="option"
        :data="data"
        :page.sync="page"
        ref="crud"
        @row-del="rowDel"
        v-model="form"
        :permission="permissionList"
        @row-update="rowUpdate"
        @row-save="rowSave"
        :before-open="beforeOpen"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @selection-change="selectionChange"
        @on-load="onLoad">
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList, getDetail, submit, remove } from '@/api/health/sleepImprovementGuidance'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      params1: {
        status: 3
      },
      selectionList: [],
      option: {
        searchMenuSpan: 12,
        tip: false,
        border: true,
        index: true,
        viewBtn: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        selection: false,
        align: 'center',
        column: [
          {
            label: '姓名',
            prop: 'name',
            search: true
          },
          {
            label: '手机号码',
            prop: 'mobile',
            search: true
          },
          {
            label: '复查项目',
            prop: 'diary',

            dicData: [
              { label: '未完成', value: 0 },
              { label: '已完成', value: 1 }
            ]
          },
          {
            label: '复查时间',
            prop: 'behavior',
            dicData: [
              { label: '未完成', value: 0 },
              { label: '已完成', value: 1 }
            ]
          }
        ]
      },
      data: [
        {
          name: '奥特曼',
          mobile: '18360238600',
          diary: '项目1',
          behavior: '2024-04-28 20:57:22'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList () {
      return {
        addBtn: this.permission.shop_order_add,
        viewBtn: this.permission.shop_order_view,
        delBtn: this.permission.shop_order_delete,
        editBtn: this.permission.shop_order_edit
      }
    },
    ids () {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    rowSave (row, done, loading) {
      submit(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }).catch(() => {
        loading()
      })
    },
    rowUpdate (row, index, done, loading) {
      submit(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }).catch(() => {
        loading()
      })
    },
    rowDel (row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(row.id)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
    },
    searchReset () {
      this.onLoad(this.page)
    },
    searchChange (params, done) {
      console.log('test searchChange')
      console.log(params)
      console.log(this.params1)
      this.params1 = params
      this.params1.status = 3
      console.log(this.params1)
      this.onLoad(this.page)
      done()
    },
    selectionChange (list) {
      this.selectionList = list
    },
    refreshChange (data) {
      console.log('test')
      console.log(data)
      console.log(this.params1)
      this.params1 = data.searchForm
      this.params1.status = 3
      console.log(this.params1)
      this.onLoad(this.page)
    },
    handleDelete () {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(this.ids)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$refs.crud.toggleSelection()
        })
    },

    beforeOpen (done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data
        })
      }
      done()
    },
    onLoad (page) {
      getList(page.currentPage, page.pageSize, this.params1).then(res => {
        // console.log('test')
        // console.log(res)
        // const data = res.data
        // this.page.total = data.total
        // this.data = data.records
        // this.data
      })
    }
  }
}
</script>
